import React from "react";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import ConstructionOutlined from "@mui/icons-material/ConstructionOutlined";
import IdentidadeVisual from "../../estilos/identidadeVisual";
import { obterTemaSear } from "../../estilos/tema";
import { SearLogo as MarcaAcesso } from "../../paginas/telaDeLogin/loginpage";

export default function TelaManutencao() {
  return (
    <ThemeProvider theme={obterTemaSear("claro")}>
      <CssBaseline />
      <IdentidadeVisual variante="acesso">
        <Box sx={{ width: "100%", maxWidth: "380px", mx: "auto", pb: { xs: 0, sm: 7 } }}>
          <MarcaAcesso />
          <Box
            component="main"
            aria-labelledby="titulo-manutencao"
            sx={{
              width: "100%",
              p: "28px 22px 30px",
              borderRadius: "12px",
              border: "1px solid rgba(255,255,255,0.85)",
              background: "linear-gradient(145deg, #ffffff 0%, #f9fcff 60%, #edf5ff 100%)",
              boxShadow: "0 16px 36px rgba(0,30,104,0.28)",
              textAlign: "center",
            }}
          >
            <Box sx={{
              width: 56, height: 56, mx: "auto", mb: "18px",
              display: "flex", alignItems: "center", justifyContent: "center",
              borderRadius: "50%", backgroundColor: "#e0ecff",
            }} aria-hidden="true">
              <ConstructionOutlined sx={{ color: "#0060ef", fontSize: 30 }} />
            </Box>
            <Typography component="h1" id="titulo-manutencao" sx={{
              mb: "18px", color: "#1b2149", fontSize: "24px", fontWeight: 700,
              textWrap: "balance",
            }}>
              Estamos em manutenção
            </Typography>
            <Typography sx={{ color: "#495c77", mb: "16px" }}>
              Estamos atualizando o SEAR. Durante esse período, as operações estão temporariamente indisponíveis.
            </Typography>
            <Typography sx={{ color: "#1b2149", fontWeight: 500 }}>
              Por favor, tente novamente mais tarde.
            </Typography>
          </Box>
        </Box>
      </IdentidadeVisual>
    </ThemeProvider>
  );
}


